<template>
    <div style="height: 100%">
      <div style="display: flex; width: 100%">
        <div style="width: 90%; height: 40px">
          <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
            <el-input v-model="formDatas.scpsName" style="width: 140px;" size="mini" placeholder="请输入名称" clearable></el-input>
            <el-select size="mini" v-model="formDatas.spId" clearable @change="partserch" placeholder="请选择项目" style="width: 130px">
                <el-option v-for="item in projectAll || []" :label="item.spName" :value="item.spId" :key="item.spId">
                  <span v-if="item.spStatus==1||item.spStatus==2||item.spStatus==3" style="color: green;">{{ item.spName }}</span>
                  <span v-if="item.spStatus==4" style="color: orange;">{{ item.spName }}</span>
                  <span v-if="item.spStatus==5" style="color: red;">{{ item.spName }}</span>
                </el-option>
            </el-select>
            <el-select size="mini" v-model="formDatas.scpsbId" clearable @change="partserch" placeholder="请选择数据库" style="width: 130px">
                <el-option v-for="item in sqlAll || []" :label="item.scpsbName" :value="item.scpsbId" :key="item.scpsbId"></el-option>
            </el-select>
            <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="margin-left: 10px">搜索</el-button>
          </el-row>
        </div>
        <div style="width: 10%; height: 40px">
          <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
            <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
          </el-row>
        </div>
      </div>
      <div class="tablemain">
        <div class="tablecss">
          <div style="width: 100%">
            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
              :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
              :checkbox-option="checkboxOption" row-key-field-name="scpsId" :cellSelectionOption="cellSelectionOption"
              style="width: 100%" :editOption="editOption" />
              <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
          </div>
          <div class="table-pagination">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
              @on-page-size-change="pageSizeChange" />
          </div>
        </div>
        <!-- 新增 -->
        <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑数据库记录' : '新增数据库记录'" :before-close="handleClose"
          :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
          <div class="demo-drawer__content" style="height: 90%;">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
              <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                <el-form-item label="备份标题" prop="scpsName">
                  <el-input v-model="form.scpsName" style="width: 80%;" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="备份地址" prop="scpsPath">
                    <cj-upload ref="xlcjupload" @fileChange="scpsPathUpfileChange" type="text" :filearr="fileList" :limit="1" style="margin: 10px 5px 5px;"></cj-upload>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="demo-drawer__footer" style="margin-top: 10px;">
            <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
            <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
              确 定</el-button>
          </div>
        </el-drawer>
      </div>
    </div>
  </template>
  
  <script>
  
  import { getSysCjProjectList,getSysCjProjectSqlBaseList,getSysCjProjectSqlList,addSysCjProjectSql,updateSysCjProjectSql,deleteSysCjProjectSql } from "../../api/api";
  export default {
    name: "",
    components: {},
    data() {
      return {
        dialog: false,
        edit: false,
        fileList: [],
        projectAll: [],
        sqlAll: [],
        form: {
          spId:null,
          scpsbId:null,
          scpsName: '',
          scpsPath: '',
        },
        rules: {},
        // 未编辑前的值
        lastValue: "",
        // 单元格编辑功能
        editOption: {
          beforeCellValueChange: ({ row, column, changeValue }) => {
            this.beforeCellValChange(row, column, changeValue);
          },
          afterCellValueChange: ({ row, column, changeValue }) => {
            this.afterCellValChange(row, column, changeValue);
          },
        },
        cellSelectionOption: {
          // disble cell selection
          enable: true,
        },
        totalCount: 100,
        pageIndex: 1,
        pageSize: 20,
        selectedRowKeysCollection: [],
        checkboxOption: {
          // 可控属性
          selectedRowKeys: [],
          // 行选择改变事件
          selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
            this.changeSelectedRowKeys(row, isSelected);
          },
          // 全选改变事件
          selectedAllChange: ({ isSelected, selectedRowKeys }) => {
            this.changeSelectAll(isSelected, selectedRowKeys);
          },
        },
        cellStyleOption: {
          headerCellClass: ({ column, rowIndex }) => {
            if (rowIndex === 0) {
              return "table-header-cell-class";
            }
          },
        },
        windheight: "",
        tableHight: 520,
        columns: [
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "scpsbName",
            key: "scpsbName",
            title: "数据库名称",
            width: 160,
            align: "center",
            edit: false,
          },
          {
            field: "scpsName",
            key: "scpsName",
            title: "备份标题",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpsPath",
            key: "scpsPath",
            title: "备份地址",
            width: 400,
            align: "center",
            edit: false,
          },
          { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
          { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, align: "center" },
          {
            field: "",
            key: "d",
            title: "操作",
            width: 200,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button>
                </span>
              );
            },
          },
        ], //表格的列
        tableData: [],
        post: null,
        formDatas: {
          spId:null,
          scpsbId:null,
          scpsName: "",
          currentPage: 1,
          pageSize: 20,
        },
      };
    },
    activated() {
        getSysCjProjectList().then(res => {
            this.projectAll = res.data
        });
        getSysCjProjectSqlBaseList().then(res => {
            this.sqlAll = res.data
        });
        this.getList();
      this.watchFlag = true;
      this.$nextTick(() => {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      });
    },
    watch: {
      "$store.state.windheight"(val) {
        this.$nextTick(() => {
          if (this.watchFlag) {
            this.tableHight = val - 200 - val * 0.04;
          }
        });
      },
    },
    deactivated() {
      this.watchFlag = false;
    },
    created() {
      this.windheight = this.$store.state.windheight
      this.tableHight =  this.windheight - 200 -  this.windheight * 0.04;
      this.getList();
    },
    mounted() { },
    methods: {
        scpsPathUpfileChange(file) {
            this.$set(this.form, 'scpsPath', file[0])
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        handleDelete(row){
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            })
            .then(() => {
                const s = {scpsIds:row.scpsId}
                console.log(s);
                deleteSysCjProjectSql({scpsIds:row.scpsId}).then(res=>{
                if(res.data){
                    this.$message({
                type: "success",
                message: "删除成功!",
                });
            
                this.partserch()
                }
                })
            }).catch(() => {
                this.$message({
                type: "info",
                message: "已取消",
                });
            })
        },
        handleEdit(row){
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(()=>{
                    this.form = data;
                    // this.form.scpsPath = data.scpsPath.split(',')
                    // if (data.scpsPath.length > 0) {
                    //     this.form.scpsPath.forEach((item, index) => {
                    //     const img = {
                    //         name: item,
                    //         url: item,
                    //     }
                    //     this.$set(this.fileList, index, img)
                    //     })
    
                    // }
                })
        },
        SureBtn() {
            if(!this.edit){
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            })
            .then(() => {
                this.form.spId=this.formDatas.spId;
                this.form.scpsbId=this.formDatas.scpsbId;
                addSysCjProjectSql(this.form).then(res=>{
                if(res.data){
                    this.$message({
                type: "success",
                message: "新增成功!",
                });
                this.handleClose()
                this.getList()
                }
                })
            }).catch(() => {
                this.$message({
                type: "info",
                message: "已取消",
                });
            })
            }else{
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            })
            .then(() => {
                updateSysCjProjectSql(this.form).then(res=>{
                if(res.data){
                    this.$message({
                type: "success",
                message: "编辑成功!",
                });
                this.handleClose()
                this.getList()
                }
                })
            }).catch(() => {
                this.$message({
                type: "info",
                message: "已取消",
                });
            })
            }
            
        },
        BoxOpen() {
            if(!this.formDatas.spId){
                this.$message({
                type: "warning",
                message: "请选择项目",
                });
                return;
            }
            if(!this.formDatas.scpsbId){
                this.$message({
                type: "warning",
                message: "请选择数据库",
                });
                return;
            }
            this.form.scpsName=this.getDatetimeValue();
            this.dialog = true;
        },
        // 获取当前时间
        getDatetimeValue(){
            // 获取当前时间
            const now = new Date();
            // 格式化时间
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const day = now.getDate();
            const hour = now.getHours();
            const minute = now.getMinutes();
            const second = now.getSeconds();
            const currentTime = `${year}-${month >= 10 ? month : '0' + month}-${day >= 10 ? day : '0' + day} ${hour >= 10 ? hour : '0' + hour}:${minute >= 10 ? minute : '0' + minute}:${second >= 10 ? second : '0' + second}`;
            // 将格式化后的时间存入 data 中
            const currentTimeTwo = `${year}${month >= 10 ? month : '0' + month}${day >= 10 ? day : '0' + day}`;
            return currentTimeTwo;
        },

      // 关闭弹框
      handleClose() {
        this.dialog = false;
        this.edit = false;
        this.$refs['formRef'].resetFields();
      },
      // 修改单元格
      async beforeCellValChange(row, column, changeValue) {
        if (row[column.field] == changeValue) {
          return false;
        }
  
        this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var jsonObj = {};
            let formData = new FormData();
            formData.append(column.field, changeValue);
            formData.forEach((value, key) => (jsonObj[key] = value));
            jsonObj.scpsId = row.scpsId
            updateSysCjProjectSql(jsonObj).then(res=>{
              this.$message({
              type: "success",
              message: "编辑成功!",
            });
            })
           
          })
          .catch(() => {
            this.lastValue = row[column.field];
            this.$nextTick(() => {
              this.tableData.forEach((item) => {
                for (let key in item) {
                  if (key == column.field && item[key] == changeValue) {
                    item[key] = this.lastValue;
                  }
                  console.log(key);
                }
              });
            });
            this.$message({
              type: "info",
              message: "已取消编辑",
            });
            return false;
          });
      },
      afterCellValChange(row, column, changeValue) {
        // console.log(" afterCellValChange", row, column, changeValue);
      },
      resetSelectedRowKeys() {
        console.log(this.checkboxOption.selectedRowKeys,this.selectedRowKeysCollection);
        this.checkboxOption.selectedRowKeys = [];
  
        const selectedRowKeysCollection = this.selectedRowKeysCollection;
  
        if (selectedRowKeysCollection.length) {
          this.tableData.forEach((item) => {
            if (selectedRowKeysCollection.indexOf(item.scpsId) > -1) {
              console.log(item);
              this.checkboxOption.selectedRowKeys.push(item.scpsId);
            }
          });
        }
      },
      changeSelectAll(isSelected, selectedRowKeys) {
        console.log(isSelected,selectedRowKeys);
        this.checkboxOption.selectedRowKeys = selectedRowKeys;
  
        if (isSelected) {
          this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
        } else {
          this.tableData.forEach((item,index) => {
            if (this.selectedRowKeysCollection.indexOf(item.scpsId) > -1) {
              this.selectedRowKeysCollection.splice(index, 1);
            }
          });
        }
      },
      changeSelectedRowKeys(row, isSelected) {
        const rowKey = row.scpsId;
  
        if (isSelected) {
          this.checkboxOption.selectedRowKeys.push(rowKey);
          this.selectedRowKeysCollection.push(rowKey);
          console.log( this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
        } else {
          const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
          this.checkboxOption.selectedRowKeys.splice(index, 1);
          this.selectedRowKeysCollection.splice(index, 1);
        }
      },
      pageSizeChange(pageSize) {
      
        this.formDatas.pageSize = pageSize;
        this.partserch();
        
        
      },
      pageNumberChange(pageIndex) {
        console.log(pageIndex);
        this.formDatas.currentPage = pageIndex;
        getSysCjProjectSqlList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      
      },
      partserch() {
        this.formDatas.currentPage = 1;
        getSysCjProjectSqlList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      },
      getList() {
        getSysCjProjectSqlList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
        });
      },
    },
  };
  </script>
  
  <style>
  .table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
  }
  
  .easetable::-webkit-scrollbar {
    display: none;
  }
  
  .ve-table-container {
    height: auto !important;
  }
  </style>
  